/**
 * Supabase Browser Client
 *
 * Re-exports the singleton Supabase client from @/lib/supabase
 * to avoid creating multiple GoTrueClient instances.
 */

import { supabase } from '@/lib/supabase';

/**
 * Returns the singleton Supabase client for browser-side usage.
 *
 * This client:
 * - Automatically persists sessions
 * - Handles token refresh
 * - Detects OAuth callback in URL
 *
 * @returns Typed Supabase client singleton
 */
export function createClient() {
  return supabase;
}
